import ProductContainer from "../../../components/applications/eCommerce/product";

const Product = () => {
  return <ProductContainer />;
};

export default Product;
